/**
 * Image URL helpers — transform Unsplash URLs to smaller, faster variants
 * and return a thumbnail-sized version for product cards / marquee.
 * Base64 data URLs and other hosts are returned unchanged.
 */

export const thumbUrl = (url, size = 400) => {
  if (!url || typeof url !== 'string') return url;
  if (url.startsWith('data:')) return url;
  // Unsplash supports ?w= and ?q= for fast variants
  if (url.includes('unsplash.com')) {
    const u = new URL(url, 'https://images.unsplash.com');
    u.searchParams.set('w', String(size));
    u.searchParams.set('q', '70');
    u.searchParams.set('auto', 'format');
    u.searchParams.set('fit', 'crop');
    return u.toString();
  }
  return url;
};

export default thumbUrl;
